var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Lead',{staticClass:"residential-lead",attrs:{"reference":{ onModel: 'Project', ref: _vm.$path('project.id', _vm.item) },"scope":{ onModel: 'Residential', ref: _vm.item.id }}})
}
var staticRenderFns = []

export { render, staticRenderFns }